// frontend/src/context/CashierContext.js

class CashierState {
    constructor() {
        // --- ESTADO INICIAL (Basado en tu appState original) ---
        this.state = {
            // Variables de Flujo (Wizard)
            step: 1,                 // 1: Pista, 2: Carrera, 3: Apuesta, 4: Confirmación
            
            // Cachés Globales
            allTracks: [],           
            allRaces: [],            
            allBetTypes: [],         
            allSignals: [],          

            // Selecciones Actuales
            selectedTrack: null,     
            selectedRace: null,      
            
            // Variables Monetarias (Restauradas de tu código)
            exchangeRate: 0.00,
            availableCurrencies: [
                { code: 'USD', symbol: '$' },
                { code: 'COP', symbol: '$' },
                { code: 'VES', symbol: 'Bs.' }
            ],
            currency: localStorage.getItem('cashier_currency') || 'USD',
            
            // Array de apuestas unificadas para el nuevo diseño
            // Formato: { horseId, horseNumber, horseName, win, place, show }
            bets: [],                
            
            // Configuración del Cajero (Mantenemos tu estructura original)
            config: {
                phone_number: '',                   
                venta_ticket_max: 0,                
                pago_premio_max: 0.00,              
                monto_minimo_ticket: 1.00,          
                monto_maximo_ticket: 500.00,        
                hourly_pay: 0.00,                   
                amount_owed: 0.00,                  
            }
        };

        // Arreglo para almacenar los componentes que "escuchan" los cambios
        this.listeners = [];         
    }

    // ==========================================
    // SISTEMA DE SUSCRIPCIÓN (Re-renderizado)
    // ==========================================
    
    // Permite que un componente (ej. CashierPage) se entere cuando algo cambia
    subscribe(listener) {
        this.listeners.push(listener);
    }

    // Avisa a todos los componentes suscritos que hubo un cambio
    notify() {
        this.listeners.forEach(listener => listener(this.state));
    }

    // Método principal para modificar variables
    update(newState) {
        this.state = { ...this.state, ...newState };
        this.notify();
    }

    // ==========================================
    // ACCIONES ESPECÍFICAS DEL WIZARD
    // ==========================================

    nextStep() { 
        this.update({ step: this.state.step + 1 }); 
    }
    
    prevStep() { 
        if (this.state.step > 1) {
            this.update({ step: this.state.step - 1 }); 
        } 
    }

    // Limpia las variables para procesar el siguiente cliente
    resetSale() { 
        this.update({ 
            step: 1, 
            selectedTrack: null, 
            selectedRace: null, 
            bets: [] 
        }); 
    }

    // Cambia la moneda globalmente
    setCurrency(currencyCode) {
        localStorage.setItem('cashier_currency', currencyCode);
        this.update({ currency: currencyCode });
    }

    // ==========================================
    // LÓGICA DE APUESTAS (ANTI-DUPLICIDAD)
    // ==========================================
    
    addBet(newBet) {
        // Obtenemos los límites de la configuración
        const maxLimit = parseFloat(this.state.config.monto_maximo_ticket) || 500;
        
        // Sumamos el monto total de esta jugada individual
        const betTotal = (newBet.win || 0) + (newBet.place || 0) + (newBet.show || 0);
        
        if (betTotal > maxLimit) {
            throw new Error(`El monto supera el límite máximo permitido por ticket ($${maxLimit}).`);
        }

        const newBetsArray = [...this.state.bets];
        const existingIndex = newBetsArray.findIndex(b => b.horseId === newBet.horseId);
        
        if (existingIndex >= 0) {
            // Si el caballo ya estaba en la lista, SUMAMOS los montos inteligentemente
            const currentTotal = newBetsArray[existingIndex].win + newBetsArray[existingIndex].place + newBetsArray[existingIndex].show;
            
            if ((currentTotal + betTotal) > maxLimit) {
                throw new Error(`La suma para este caballo superaría el límite de $${maxLimit}.`);
            }

            newBetsArray[existingIndex].win += (newBet.win || 0);
            newBetsArray[existingIndex].place += (newBet.place || 0);
            newBetsArray[existingIndex].show += (newBet.show || 0);
        } else {
            // Si no estaba, lo agregamos como nuevo
            newBetsArray.push(newBet);
        }

        this.update({ bets: newBetsArray });
    }

    removeBet(horseId) {
        const filteredBets = this.state.bets.filter(b => b.horseId !== horseId);
        this.update({ bets: filteredBets });
    }
}

// Exportamos la instancia única (Singleton)
export const cashierContext = new CashierState();